import Vue from 'vue'
import store from './store'
import router from './router'
import App from './pages/App'
import moment from 'moment'
import MomentJS from 'vue-moment'
import * as Sentry from '@sentry/browser'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'
import {
  faLock,
  faUserGraduate,
  faBars,
  faSignOutAlt,
  faArrowRight,
  faUser,
  faUserTie,
  faTag,
  faCalendarAlt,
  faPaperclip,
  faPrint,
  faSearch,
  faChevronRight,
  faLongArrowAltRight,
  faTimesCircle,
  faFileExcel,
  faFileWord,
  faFileImage,
  faFilePdf,
  faFileAlt,
  faSyncAlt,
  faExclamationCircle,
  faAngleDoubleRight,
  faAngleDoubleLeft
} from "@fortawesome/free-solid-svg-icons";

import {
  faFile,
  faEdit,
  faTrashAlt,
  faPlusSquare,
  faClock

} from '@fortawesome/free-regular-svg-icons'
moment.updateLocale('en', {
  weekdaysShort: ['日', 'ㄧ', '二', '三', '四', '五', '六']
})
Vue.use(MomentJS, {
  moment
})
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
library.add(
  faLock,
  faUserGraduate,
  faBars,
  faSignOutAlt,
  faArrowRight,
  faUser,
  faUserTie,
  faFile,
  faTag,
  faCalendarAlt,
  faPaperclip,
  faPrint,
  faSearch,
  faChevronRight,
  faEdit,
  faTrashAlt,
  faPlusSquare,
  faLongArrowAltRight,
  faClock,
  faTimesCircle,
  faFileExcel,
  faFileWord,
  faFileImage,
  faFilePdf,
  faFileAlt,
  faSyncAlt,
  faExclamationCircle,
  faAngleDoubleRight,
  faAngleDoubleLeft
)
Vue.config.silent = true
Vue.config.productionTip = false
Sentry.init({
  dsn: process.env.MIX_SENTRY_DSN,
  environment: process.env.MIX_SENTRY_ENV
})

if (typeof window === 'undefined') {
  global.window = {}
}
export default new Vue({
  // eslint-disable-line no-new
  store,
  router,
  render: h => h(App)
})
